var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 10V8.66671C26.6667 6.79987 26.6667 5.86644 26.3034 5.15341C25.9838 4.5262 25.4738 4.01626 24.8466 3.69669C24.1336 3.33337 23.2002 3.33337 21.3333 3.33337H18.6667C16.7998 3.33337 15.8664 3.33337 15.1534 3.69669C14.5262 4.01626 14.0162 4.5262 13.6966 5.15341C13.3333 5.86644 13.3333 6.79987 13.3333 8.66671V10M16.6667 19.1667V27.5M23.3333 19.1667V27.5M5 10H35M31.6667 10V28.6667C31.6667 31.467 31.6667 32.8671 31.1217 33.9367C30.6423 34.8775 29.8774 35.6424 28.9366 36.1217C27.8671 36.6667 26.4669 36.6667 23.6667 36.6667H16.3333C13.5331 36.6667 12.1329 36.6667 11.0634 36.1217C10.1226 35.6424 9.35767 34.8775 8.8783 33.9367C8.33333 32.8671 8.33333 31.467 8.33333 28.6667V10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f0dba73fed66c92d8edcf19f56b85f7e.svg";
export { ForwardRef as ReactComponent };